import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.function.name";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import differenceInDays from 'date-fns/differenceInDays';
import classnames from 'classnames';
import StarRating from '@nerdwallet/react-star-rating'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import get from 'lodash/get';
import LoginPopover from './login-popover';
import { ElementInteraction } from '../tracking';
import './comment-tab-design.less';

function getDaysSinceDate(date) {
  return differenceInDays(new Date(), date);
}

var propTypes = {
  gigya: PropTypes.shape({
    // eslint-disable-next-line react/forbid-prop-types -- directive added automatically by Shepherd migration
    user: PropTypes.object
  }),
  comment: PropTypes.shape({
    timestamp: PropTypes.number,
    // eslint-disable-next-line react/forbid-prop-types -- directive added automatically by Shepherd migration
    ratings: PropTypes.object,
    commentTitle: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types -- directive added automatically by Shepherd migration
    sender: PropTypes.object,
    commentText: PropTypes.string,
    vote: PropTypes.oneOf(['pos', 'neg', 'none']),
    TotalVotes: PropTypes.number,
    ID: PropTypes.string
  }),
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  streamID: PropTypes.string,
  voteComment: PropTypes.func,
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  elementPosition: PropTypes.string
};
var defaultProps = {
  gigya: {},
  comment: {},
  voteComment: function voteComment() {}
}; // FYI: negative voting is only allowed when configured in global settings for Gigya.
// See DevOps to get the configuration changed through the Gigya dashboard.

var VOTES = {
  YES_VOTE: 'pos',
  NO_VOTE: 'neg',
  NONE_VOTE: 'none'
};

var TabDesignComment =
/*#__PURE__*/
function (_Component) {
  _inherits(TabDesignComment, _Component);

  function TabDesignComment(props) {
    var _this;

    _classCallCheck(this, TabDesignComment);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TabDesignComment).call(this, props));
    _this.voteComment = _this.voteComment.bind(_assertThisInitialized(_this));
    _this.handleVoteClick = _this.handleVoteClick.bind(_assertThisInitialized(_this));
    _this.getNewVoteValue = _this.getNewVoteValue.bind(_assertThisInitialized(_this));
    _this.hideLoginPopover = _this.hideLoginPopover.bind(_assertThisInitialized(_this));
    _this.handleLoginPopoverClick = _this.handleLoginPopoverClick.bind(_assertThisInitialized(_this));
    _this.state = {
      showLoginPopover: false
    };
    return _this;
  }

  _createClass(TabDesignComment, [{
    key: "getNewVoteValue",
    value: function getNewVoteValue(newVote) {
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      var currentVote = this.props.comment.vote;
      /*
        new vote will always be pos or neg
        if current === pos and new === pos
          return none
        if current === pos and new === neg
          return neg
        if current === neg and new === neg
          return none
        if current === neg and new === pos
          return pos
        if current === none or !current
          return new
      */

      if (currentVote === newVote) {
        return VOTES.NONE_VOTE;
      }

      if (!currentVote || VOTES.NONE_VOTE || currentVote !== newVote) {
        return newVote === VOTES.YES_VOTE ? VOTES.YES_VOTE : VOTES.NO_VOTE;
      }

      return VOTES.NONE_VOTE;
    }
  }, {
    key: "voteComment",
    value: function voteComment(provider, newVote) {
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      this.props.voteComment({
        provider: provider,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        streamID: this.props.streamID,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        commentID: this.props.comment.ID,
        vote: this.getNewVoteValue(newVote),
        voteButtonPressed: newVote,
        // if value is 'none', we need to know from which vote to subtract
        allowNegativeVotes: true
      });
    }
  }, {
    key: "handleVoteClick",
    value: function handleVoteClick(e) {
      var gigya = this.props.gigya; // eslint-disable-next-line react/prop-types -- directive added automatically by Shepherd migration

      var isLoggedIn = gigya.auth.loginToken.get() !== null;

      if (!isLoggedIn) {
        this.setState({
          showLoginPopover: true
        });
      } else {
        this.voteComment(null, e.currentTarget.value);
      }
    }
  }, {
    key: "hideLoginPopover",
    value: function hideLoginPopover() {
      this.setState({
        showLoginPopover: false
      });
    }
  }, {
    key: "handleLoginPopoverClick",
    value: function handleLoginPopoverClick(provider) {
      // Pass login provider to use for login before posting comment
      this.voteComment(provider);
      this.hideLoginPopover();
    }
  }, {
    key: "renderLoginPopover",
    value: function renderLoginPopover() {
      return (// eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        this.state.showLoginPopover && React.createElement(ElementInteraction, {
          id: "nw-comment__login-popover",
          elementName: "nw-comment__login-popover",
          sectionCategory: "comment",
          elementCategory: "popover"
        }, React.createElement(LoginPopover, {
          onClick: this.handleLoginPopoverClick,
          onClose: this.hideLoginPopover
        }))
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          comment = _this$props.comment,
          gigya = _this$props.gigya;
      var days = getDaysSinceDate(comment.timestamp);
      var timeSincePosted = days === 1 ? '1 day ago' : "".concat(days, " days ago");
      var yesButtonClasses = classnames('nw-review-comment__yes', {
        liked: comment.vote === VOTES.YES_VOTE && gigya.user
      });
      var noButtonClasses = classnames('nw-review-comment__no', {
        liked: comment.vote === VOTES.NO_VOTE && gigya.user
      });
      return React.createElement("article", {
        className: "nw-review-comment"
      }, React.createElement("header", null, React.createElement("section", {
        className: "nw-review-comment__title"
      }, React.createElement("div", {
        className: "nw-review-comment__summary"
      }, comment.commentTitle), React.createElement("div", {
        className: "nw-review-comment__rating"
      }, React.createElement(StarRating, {
        rating: get(comment, 'ratings._overall')
      }))), React.createElement("section", {
        className: "nw-review-comment__user"
      }, React.createElement("div", {
        className: "nw-review-comment__username"
      }, "By ", comment.sender.name), React.createElement("div", {
        className: "nw-review-comment__time"
      }, timeSincePosted))), React.createElement("section", {
        className: "nw-review-comment__body"
      }, React.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: comment.commentText
        }
      })), React.createElement("footer", {
        className: "nw-review-comment__footer"
      }, React.createElement("div", {
        className: "nw-review-comment__footer--left"
      }, React.createElement("p", {
        className: "nw-review-comment__review-helpful"
      }, "Was this review helpful?"), React.createElement("ul", {
        className: "nw-review-comment__linksContainer"
      }, React.createElement(ElementInteraction, {
        type: "CLICK",
        id: "nw-review-comment__like",
        elementName: "nw-review-comment__like",
        sectionCategory: "comment",
        elementCategory: "button",
        elementDomType: "button" // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        ,
        elementPosition: this.props.elementPosition
      }, React.createElement("li", {
        className: yesButtonClasses
      }, React.createElement("button", {
        className: "nw-review-comment__vote__count",
        onClick: this.handleVoteClick,
        type: "button",
        value: VOTES.YES_VOTE
      }, "Yes", comment.posVotes))), React.createElement(ElementInteraction, {
        type: "CLICK",
        id: "nw-review-comment__dislike",
        elementName: "nw-review-comment__dislike",
        sectionCategory: "comment",
        elementCategory: "button",
        elementDomType: "button" // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        ,
        elementPosition: this.props.elementPosition
      }, React.createElement("li", {
        className: noButtonClasses
      }, React.createElement("button", {
        className: "nw-review-comment__vote__count",
        onClick: this.handleVoteClick,
        type: "button",
        value: VOTES.NO_VOTE
      }, "No", comment.negVotes === undefined ? 0 : comment.negVotes))), this.renderLoginPopover()))));
    }
  }]);

  return TabDesignComment;
}(Component); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


TabDesignComment.displayName = 'TabDesignComment'; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

TabDesignComment.propTypes = propTypes; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

TabDesignComment.defaultProps = defaultProps;
export default TabDesignComment;